import React from 'react'

const ClosedEye = (
    props: React.SVGProps<SVGSVGElement>
): React.ReactElement => {
    return (
        <svg
            width="15"
            height="12"
            viewBox="0 0 15 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M14.9211 5.95559L14.7458 5.74124C14.7068 5.70227 13.9858 4.78645 12.7387 3.87062C11.063 2.64303 9.25081 2 7.47762 2C5.70442 2 3.89226 2.64303 2.21649 3.87062C1.00838 4.78645 0.267928 5.70227 0.248442 5.74124L0.0730712 5.95559C-0.0243571 6.0725 -0.0243571 6.24787 0.0730712 6.36479L0.248442 6.57913C0.287413 6.6181 1.00838 7.53392 2.25546 8.44975C3.93123 9.67735 5.74339 10.3204 7.51659 10.3204C9.28978 10.3204 11.1019 9.67735 12.7777 8.44975C14.0248 7.53392 14.7458 6.6181 14.7847 6.57913L14.9601 6.36479C15.0186 6.24787 15.0186 6.0725 14.9211 5.95559ZM7.4971 9.34609C5.72391 9.34609 4.30146 7.92364 4.30146 6.15044C4.30146 4.37725 5.72391 2.9548 7.4971 2.9548C9.2703 2.9548 10.6927 4.37725 10.6927 6.15044C10.6927 7.92364 9.2703 9.34609 7.4971 9.34609Z"
                fill="#696158"
            />
            <path
                d="M7.49733 3.96802C6.28922 3.96802 5.31494 4.9423 5.31494 6.15041C5.31494 7.35852 6.28922 8.3328 7.49733 8.3328C8.70544 8.3328 9.67973 7.35852 9.67973 6.15041C9.67973 4.9423 8.70544 3.96802 7.49733 3.96802ZM9.1731 6.15041C9.1731 7.06623 8.43265 7.82618 7.49733 7.82618C7.30248 7.82618 7.16608 7.67029 7.16608 7.49492C7.16608 7.39749 7.20505 7.31955 7.26351 7.26109C7.32196 7.20263 7.39991 7.16366 7.49733 7.16366C8.04293 7.16366 8.4911 6.71549 8.4911 6.1699C8.4911 5.97504 8.64699 5.83864 8.82236 5.83864C9.01721 5.81915 9.1731 5.97504 9.1731 6.15041Z"
                fill="#696158"
            />
            <line
                x1="12.9841"
                y1="0.706927"
                x2="1.70688"
                y2="11.4873"
                stroke="#696158"
                strokeLinecap="round"
            />
        </svg>
    )
}

export default ClosedEye
